export default "__VITE_PUBLIC_ASSET__d254bb41__"